import React, { useContext } from 'react';
import styles from './PermissionsPath.module.css';
import { ArrowRightTriangleIcon } from 'assets/icons';
import ThemeContext from 'config/context/themeContext';

const PermissionsPath = ({ path, setPath }) => {
    const { dark } = useContext(ThemeContext);

    const handleClick = (index) => {
        const newPath = path.slice(0, index + 1);
        setPath(newPath);
    };

    return (
        <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
            {path.map((p, index) => (
                <span key={index} className={styles.breadcrumb}>
                    <button
                        className={`${styles.crumb} ${index === path.length - 1 ? styles.active : ''}`}
                        onClick={() => handleClick(index)}
                    >
                        {p}
                    </button>
                    {index < path.length - 1 && (
                        <span className={styles.separator}><ArrowRightTriangleIcon color={dark ? "#a8a8a8" : ""} /></span>
                    )}
                </span>
            ))}
        </div>
    );
};

export default PermissionsPath;
